import React, { memo } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Award, Calendar } from 'lucide-react';
const ProgramasClientes = () => {
  return <div className="flex flex-col min-h-screen w-full" data-id="element-326">
      <Header data-id="element-327" />
      <main data-id="element-328">
        {/* Hero Section */}
        <section className="bg-gradient-to-r from-promred-gray to-gray-700 text-white py-16 md:py-20" data-id="element-329">
          <div className="container mx-auto px-4 text-center" data-id="element-330">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4" data-id="element-331">
              Nuestros Clientes
            </h1>
            <p className="text-lg md:text-xl text-gray-100 max-w-3xl mx-auto" data-id="element-332">
              Conoce algunos de los eventos que organizamos para nuestros
              clientes.
            </p>
          </div>
        </section>

        {/* Programas de Fidelización Section */}
        <section className="py-16 md:py-24 bg-white" data-id="element-333"></section>

        {/* Eventos Section */}
        <section className="py-16 md:py-24 bg-gray-50" data-id="element-334">
          <div className="container mx-auto px-4" data-id="element-335">
            <div className="text-center mb-12" data-id="element-336">
              <div className="w-16 h-16 bg-promred-blue bg-opacity-10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-337">
                <Calendar className="text-promred-blue" size={32} data-id="element-338" />
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-promred-gray mb-4" data-id="element-339">
                Algunos de los Eventos que Organizamos
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-340">
                Gestionamos la operativa y tecnología de eventos memorables para
                nuestros clientes.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-341">
              {/* Evento 7 Fuegos */}
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-342">
                <h3 className="text-xl font-bold text-promred-gray mb-3" data-id="element-343">
                  7 Fuegos
                </h3>
                <div className="mb-4 aspect-video rounded-lg overflow-hidden bg-gray-200" data-id="element-344">
                  <video controls className="w-full h-full object-cover" poster="https://uploadthingy.s3.us-west-1.amazonaws.com/cnc1d1uuiBabHNzspzBg67/Logo_Promred.png" data-id="element-345">
                    <source src="https://cdn.magicpatterns.com/uploads/tKKjV3wU6J81h17WRbG5iF/Evento_7_Fuegos_HD_480.undefined" type="video/mp4" data-id="element-346" />
                    Tu navegador no soporta el elemento de video.
                  </video>
                </div>
                <p className="text-gray-600 mb-4" data-id="element-347">
                  Experiencia gastronómica única donde gestionamos todo el
                  sistema de pagos, conectividad y apoyamos a la operación en
                  general.
                </p>
              </div>

              {/* Mágica Navidad 2025 */}
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-348">
                <h3 className="text-xl font-bold text-promred-gray mb-3" data-id="element-349">
                  Mágica Navidad 2025
                </h3>
                <div className="mb-4 aspect-video rounded-lg overflow-hidden bg-gray-200" data-id="element-350">
                  <video controls className="w-full h-full object-cover" poster="https://uploadthingy.s3.us-west-1.amazonaws.com/cnc1d1uuiBabHNzspzBg67/Logo_Promred.png" data-id="element-351">
                    <source src="https://cdn.magicpatterns.com/uploads/16DVAGJqHjjKAxJWUZUMRB/MgicaNavidadconfiltroblur_480p.undefined" type="video/mp4" data-id="element-352" />
                    Tu navegador no soporta el elemento de video.
                  </video>
                </div>
                <p className="text-gray-600 mb-4" data-id="element-353">
                  Mágica Navidad fue un festival integral de emprendimiento,
                  música y teatro navideño realizado en Parque Bicentenario de
                  Samborondón, generando una experiencia inmersiva de Navidad.
                  En el colaboramos con la provisión de tecnología, gestión de
                  coordinación, atención a emprendedores y producción general.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-354" />
    </div>;
};
export default ProgramasClientes;